import React, { useState, useEffect } from 'react'
import { format } from 'date-fns'
import { Link } from 'react-router-dom';
import { MODEL_COLOR } from '../../../model/ModelColor'
import imageCorbeille from '../../../images/corbeille.png'

const BookingAuth = ({ _signOut, booking, user, profil, keyUid, clients, _handleModifInfo, handleChange, values, _handleNavigate, _converteTimeToHours, setIdResetBooking }) => {
    const [currentDate, setCurrentDate] = useState(format(new Date(Date.now()), 'MM/dd/yyyy'))

    return (
        <div>

            {/* SI CLIENT */}
             {user?.uid != keyUid ?
                <div>
                    {/* BOUTON PRENDRE RDV */}
                    <div className='text-center my-3 mt-4'>
                        <button className='btn btn-dark rounded-pill' onClick={_handleNavigate}>Prendre RDV</button>
                    </div>

                    {/* SI RESERVATION A VENIR */}
                    <div>
                    {booking.filter(b => b.uidClient === user.uid && b.date >= currentDate && b.cancel !== true).map(b => ( 
                        <div className='mt-3 row border rounded text-center mx-3' style={{backgroundColor:MODEL_COLOR.blueApply}} key={b.id}>
                            <div className='col-2' />
                            <div className='p-2 col' style={{ color:'grey'}}>Prochain RDV : {b.dateShow} à {_converteTimeToHours(b.hours)}</div>
                            <div 
                                className='col-2 text-end' /*onClick={() => _deleteBooking(b.id)}*/ 
                            >
                                <img 
                                    src={imageCorbeille} 
                                    alt='corbeille' 
                                    style={{ height:'1.5rem', width:'1.5rem', marginTop:'0.5rem', cursor:'pointer' }} 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#modalConfirm"
                                    onClick={() => setIdResetBooking(b.id)}
                                />
                            </div>
                        </div>
                    ))}
                    </div>

                    {/* HISTORIQUE DES RESERVATIONS */}
                    <div className='text-center'>Historique des RDV</div>
                    <div className='shadow row'>
                        {booking.filter(b => b.uidClient === user.uid && b.date >= currentDate && b.cancel === true).map(b => (
                            // CARD MES RENDEZ-VOUS
                            <div className='mt-2 border-bottom row' key={b.id}>
                                <div className='pt-2 pb-3'>{b.dateShow} à {_converteTimeToHours(b.hours)} : {b.nameService} {b.priceService}€  - {b.durationService}min <span className='text-danger'>Annulée</span></div>
                            </div>
                        ))}
                        {booking.filter(b => b.uidClient === user.uid && b.date < currentDate).map(b => (
                            // CARD MES RENDEZ-VOUS
                            <div className='mt-2 border-bottom row' key={b.id}>
                                <div className='pt-2 pb-3'>{b.dateShow} à {_converteTimeToHours(b.hours)} : {b.nameService} {b.priceService}€  - {b.durationService}min <span className='text-danger'>Annulée</span></div>
                            </div>
                        ))}
                    </div>

                    {/* MES INFORMATIONS */}
                    <div className='mt-4  d-grid gap-2'>
                        <div className='h5'>Mes informations</div>
                    </div>
                    {clients.filter(c => c.uid === user.uid).map(c => (
                        <div key={c.id}>
                        <div className='mt-3'>
                            <input type="text" className='form-control rounded-pill shadow' value={values.surname} name='surname' onChange={handleChange} placeholder={c.surname} />
                        </div>
                        <div className='mt-3'>
                            <input type="text" className='form-control rounded-pill shadow' value={values.surname} name='name' onChange={handleChange} placeholder={c.name} />
                        </div>
                            <div className='text-center'>
                                <button
                                    className='btn btn-outline-dark mb-3 my-3 rounded-pill'
                                    disabled={values.surname && values.surname ? false : true}
                                    onClick={() => _handleModifInfo(c.id, values.surname, values.name)}
                                >Modifier</button>
                            </div>
                        </div>
                    ))}

                    {/* CARTE DE FIDELITE */}
                    {profil.filter(p => p.id === 'profil').map(p => (
                        p.cardLoyalty &&
                            clients.filter(cl => cl.uid === user.uid).map(cl => (
                                <div key={cl.id}>
                                    <div className='h5'>carte de fidélité : {cl.countCardLoyalty} / {p.countCardLoyalty}</div>
                                </div>
                            ))
                    ))}
                </div>
            :
                <div>
                    <div className='text-center mt-5 mb-3'>
                        <Link to='/homeServeur' className='text-decoration-none btn btn-outline-dark'>partie administrateur</Link> 
                    </div>
                </div>
            }

            {/* BUTTON DECONNECTER */}
            <div className='text-center d-grid gap-2 pt-3 mt-3'>
                <button className='btn btn-dark mt-4 rounded-pill mx-2 shadow' onClick={_signOut}>Se déconnecter</button>
            </div>

            <div style={{ height:200 }} />
        
        </div>
    )
}

export default BookingAuth